<!-- main内容 -->
<template>
 <div class="content-container">
    <router-view />
  </div>
</template>

<script>
export default {
data() {
return {

}
},
created() {

},
mounted() {

},
methods: {

}
}
</script>
<style lang='scss' scoped>

</style>


// WEBPACK FOOTER //
// src/components/Content.vue